<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';
    
   export default {
      page: {
         title: "Consultations",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
          const current_date = moment().format("YYYY-MM-DD");
          const datetime_now = moment().format("YYYY-MM-DD HH:mm:ss");

         return {
            title: "Consultations",
            items: [
               {
                  text: "Consultations",
                  active: true,
               },                   
            ],

            cancel_consultation: {
               id: "",
               reason: "",
            },
            consultations: [],
            doctors: [],           
            from: null,
            to: null,
            total: null,
            pagination: {},
            keyword: "",
            listing_length: 10,
            status: "",
            doctor_id: '',
            token: "",
            errors: {},          
            active_page_url: null,

            now: datetime_now,
            today: current_date,
         };
      },
      mounted() {
         this.clearLocalStorage();
      },

      created() {
         const savedFilters = localStorage.getItem("consultation_filters");

            if (savedFilters) {
               const filters = JSON.parse(savedFilters);

               // Restore values
               this.keyword = filters.keyword || "";
               this.listing_length = filters.listing_length || 10;
               this.status = filters.status || "";
               this.doctor_id = filters.doctor_id || "";
               this.active_page_url = filters.active_page_url || null;

               // Clear stored filters
               localStorage.removeItem("consultation_filters");

               // Fetch consultations using restored filters
               this.fetchConsultations(this.active_page_url);
            } else {
               this.fetchConsultations(); // Load normally if no stored filters
            }
         this.fetchClinicDoctors();

      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");
            localStorage.removeItem("unscheduled_doctor_filters");
         },
         
         getDetailsRoute(id) {
            const filters = {
               keyword: this.keyword,
               listing_length: this.listing_length,
               status: this.status,
               doctor_id: this.doctor_id,
               active_page_url: this.active_page_url || this.$route.fullPath, // Store last visited page
            };
            localStorage.setItem("consultation_filters", JSON.stringify(filters)); // Save filters
            this.$router.push({ name: "consultations.details", params: { id: id } });
         },

         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },

         cancelModal(consultation){
            this.cancel_consultation.id = consultation.id;
            this.showModal("cancel-modal");
         }, 

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         fetchClinicDoctors(){

         let url = "clinic/clinicConsultedDoctors";      
         this.getToken();
         this.loading = true;
         this.$axios
         .get(url, { headers: { Authorization: "Bearer " + this.token } })
         .then((res) => {
            var responseData = res.data.data;
            this.doctors = responseData;
            })
            .catch((err) => console.log(err));

         },


         fetchConsultations(page_url) {

            this.getToken();
            let url = "clinic/consultations?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status+ "&doctor_id=" + this.doctor_id;

            page_url = page_url || url;

            //if(localStorage.back_url) {
            //   page_url = localStorage.back_url;  
            //   localStorage.removeItem('back_url');
            //}    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.consultations = responseData.consultations.data;
                  
                  this.pagination = responseData.consultations.links;
                  this.from = responseData.consultations.from;
                  this.to = responseData.consultations.to;
                  this.total = responseData.consultations.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         printToken(id) {
            const url = "api/downloadPrescriptionToken?booking_id=" + id;
            this.getToken();
            this.loading = true;

            this.$axios
               .get(url, {
                  headers: { Authorization: "Bearer " + this.token },
                  responseType: "blob"
               })
               .then(res => {
                  const blob = new Blob([res.data], { type: "application/pdf" });
                  const blobUrl = URL.createObjectURL(blob);

                  // Open the PDF in a new window/tab
                  const printWindow = window.open(blobUrl, '_blank');
                  
                  // Wait until the PDF loads, then trigger print
                  printWindow.onload = () => {
                  printWindow.focus();
                  printWindow.print();
                  };

                  // Optional: revoke URL after some time
                  setTimeout(() => {
                  URL.revokeObjectURL(blobUrl);
                  }, 5000);
               })
               .catch(error => {
                  console.error("Error printing PDF:", error);
                  const reader = new FileReader();
                  reader.onload = (event) => {
                  const text = event.target.result;
                  const errorData = JSON.parse(text);
                  const errorMessage = errorData.message;
                  if (errorMessage) {
                     this.errors = errorMessage;
                  } else {
                     this.$swal("", "Failed to load PDF for printing", "error");
                  }
                  };
                  reader.readAsText(error.response.data);
               });
         }, 

         completeConsultation(booking_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to mark this booking as Completed?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };
                 
                  let url = "api/admin/consultations/complete?booking_id=" + booking_id;
                  this.$axios
                  .get(url, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchConsultations(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },

         noshowConsultation(booking_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to mark this booking as No Show?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };
                 
                  let url = "api/admin/consultations/noshow?booking_id=" + booking_id;
                  this.$axios
                  .get(url, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchConsultations(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },


         cancelConsultation() {
   
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };
                 
                  let url = "clinic/consultation/cancel?booking_id=" + this.cancel_consultation.id + "&reason=" + this.cancel_consultation.reason;
                  this.$axios
                  .get(url, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchConsultations(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               
         },


      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'consultations.add' }" class="btn btn-primary float-end">Add Consultation</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-3">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchConsultations()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-9">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchConsultations()"/>
                           </label>
                        </div>
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="doctor_id" @change="fetchConsultations()">
                                 <option value="">All Doctors</option>
                                 <option :value="doctor.doctor_id" v-for="doctor in doctors" :key="doctor.doctor_id">{{doctor.name}}</option>
                              </select>
                           </label>
                        </div>                      
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change="fetchConsultations()">
                                 <option value="">All</option>
                                 <option value="1">Today's Consultations</option>
                                 <option value="2">Pending Consultations</option>
                                 <option value="3">Completed Consultations</option>
                                 <option value="4">Cancelled Consultations</option>
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th width="10%">User</th>              
                              <th width="10%">Patient</th>              
                              <th width="10%">Doctor</th>   
                              <th width="15%">Booking Date & Slot, <br> Token</th>  
                              <th width="5%">Status</th>
                              <th width="5%">Created By</th>
                              <th width="10%">Created On</th>                              
                              <th width="20%">Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(consultations.length)">
                           <tr v-for="(consultation) in consultations" :key="consultation.id">
                              <td><span v-if="consultation.patient_id">{{consultation.name}}<br>
                                 {{consultation.country_code}} {{consultation.mobile}}</span>
                                 <span v-else>Guest Patient</span>                              </td>     
                              <td>
                                 <span v-if="consultation.member">{{ consultation.member.name }}</span>
                                 <span v-else>Self</span>
                              </td>
                              <td>
                                 <span v-if="consultation.doctor"><span v-if="consultation.doctor.prefix == 1">Dr. </span><span v-else-if="consultation.doctor.prefix == 2">Mr. </span><span v-else-if="consultation.doctor.prefix == 3">Ms. </span> {{consultation.doctor.name}}</span>
                              </td>
                              <td>{{consultation.booking_date | formatDate}}<br>
                                 {{consultation.consultation_start | formatTime}} - {{consultation.consultation_end | formatTime}}<br>
                                 <span class="badge bg-primary" style="font-size: 0.9em;"> Token: {{consultation.token}}</span>
                              </td>  

                              <td>
                                 <p class="badge bg-warning" v-if="consultation.status==1">Pending</p>
                                 <p class="badge bg-success" v-if="consultation.status==2">Completed</p>
                                 <p v-if="consultation.status==3" class="badge bg-danger">
                                    Cancelled<br>
                                    <!-- <span v-if="consultation.consultation_type==1">
                                       Refund: 
                                       <span v-if="consultation.refund_status==1">Pending</span>
                                       <span v-if="consultation.refund_status==2">Completed</span>
                                    </span> -->
                                 </p>
                                 <p class="badge bg-info" v-if="consultation.status==4">No Show</p>
                              </td>
                              <td>
                                 <span v-if="consultation.added_by==1">Patient</span>
                                 <span v-if="consultation.added_by==2">Admin</span><br>
                                 <span v-if="consultation.added_by==3">Clinic</span>
                                 <!-- <span v-if="consultation.added_by==4">Clinic</span> -->
                              </td>
                              <td>
                                 {{consultation.converted_created_at}}
                              </td>
                              <td>
                                 <!--<router-link :to="{ name: 'consultations.details', params: {id: consultation.id} }" class="btn btn-primary me-2 mb-2 btn-sm" v-if="consultation.patient_id">Details</router-link>-->
                                 <button  @click="getDetailsRoute(consultation.id)" class="btn btn-primary me-2 mb-2 btn-sm" type="button" v-if="consultation.patient_id">Details</button>

                                
                                 <!-- <router-link :to="{ name: 'consultations.add', params: {id: consultation.id, doctor_id: consultation.doctor_id, name: consultation.name} }" class="btn btn-warning me-2 mb-2 btn-sm" v-if="consultation.status == 1 && (consultation.booking_date + ' ' + consultation.consultation_end)  > now && consultation.patient_id">Reschedule</router-link> -->

                                 <router-link :to="{ name: 'consultations.reschedule', params: {id: consultation.id, doctor_id: consultation.doctor_id, patient_id: consultation.patient_id, type: consultation.consultation_type, clinic_id: consultation.clinic_id } }" class="btn btn-warning me-2 mb-2 btn-sm" v-if="consultation.status == 1 && (consultation.booking_date + ' ' + consultation.consultation_end)  > now && consultation.patient_id">Reschedule</router-link>

                                 <button  @click="completeConsultation(consultation.id)" class="btn btn-success me-2 mb-2 btn-sm" type="button" v-if="consultation.status == 1 && (consultation.booking_date + ' ' + consultation.consultation_end)  < now">Mark as Completed</button>

                                 <button  @click="noshowConsultation(consultation.id)" class="btn btn-info me-2 mb-2 btn-sm" type="button" v-if="consultation.status == 1 && (consultation.booking_date + ' ' + consultation.consultation_end)  < now">Mark as No Show</button>

                                 <button  @click="cancelModal(consultation)" class="btn btn-danger me-2 mb-2 btn-sm" type="button" v-if="consultation.status == 1 && (consultation.booking_date + ' ' + consultation.consultation_end)  > now">Cancel</button>
                                 <button v-if="consultation.status == 1 && consultation.patient_id" @click="printToken(consultation.id)" class="btn btn-primary me-2 mb-2 btn-sm" type="button">
                                    Print Token
                                 </button>

                                 <!-- <button @click="refundConsultation(consultation.id)" class="btn btn-success me-2 mb-2 btn-sm" type="button" v-if="consultation.consultation_type == 1 &&consultation.status == 3 && consultation.refund_status == 1">Mark as Refunded</button> -->
                              </td>
                           </tr>
                 
                        </tbody>

                        <tbody v-else>
                           <tr>
                              <td colspan="7" class="text-center">No consultations found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption v-if="Boolean(consultations.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchConsultations(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status + '&doctor_id=' + doctor_id )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

                  <!---- modal starts ---->
                  <b-modal ref="cancel-modal" id="cancel-modal" title="Cancel Consultation" hide-footer>
                     <b-form @submit.prevent="cancelConsultation()" >
                        
                        <b-col md="12" class="form-group">
                           <label class="control-label">Reason for Cancellation</label>
                           <textarea class="form-control" rows="4" v-model="cancel_consultation.reason"></textarea>
                        </b-col>                      
                        
                        <b-col md="12">
                           <b-button type="submit" class="me-3" variant="primary" @click="hideModal('cancel-modal')">Save</b-button>
                           <b-button class="" variant="light" @click="hideModal('cancel-modal')">Close</b-button>
                        </b-col>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
